import { useState } from 'react';
import {
  Grid,
  Table,
  TableHeaderRow,
  DragDropProvider,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-material-ui';
import { Box, fade, Paper, Typography, withStyles } from '@material-ui/core';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { userroles } from '../common';
import { useTemplate } from '../hooks';
import { currencyFormatter } from '../Sections/common/formater';
import { quantityFormatter } from '../Sections/generator/common/helpers';
import { renderRelations } from '../Shared/colorFormat';

export const getRowId = (row: any) => row.index;

const IndexProvider = (props) => (
  <DataTypeProvider
    formatterComponent={({ value }) => (
      <Typography variant="subtitle2">{Number(value) + 1}</Typography>
    )}
    {...props}
  />
);

const styles = (theme) => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(theme.palette.primary.main, 0.1),
    },
  },
});

const TableComponentBase = ({ classes, ...restProps }) => (
  <Table.Table {...restProps} className={classes.tableStriped} />
);

export const TableComponent = withStyles(styles, { name: 'TableComponent' })(
  TableComponentBase
);

export default function ItemsTableView({ rows, isRTL, words }: any) {
  const { tempoptions } = useTemplate();
  const [columns] = useState(
    [
      { name: 'index', title: words.no },
      { name: isRTL ? 'nameAr' : 'name', title: words.item },
      {
        name: 'relations',
        title: isRTL ? 'مراكز التكلفة' : 'Cost Centers',
      },
      tempoptions?.itemdescription && {
        name: 'note',
        title: words.description,
      },
      (userroles?.adds?.edit || userroles?.isEmployee) && {
        name: 'itemprice',
        title: words.theprice,
      },
      { name: 'itemqty', title: words.qty },
      (userroles?.adds?.edit || userroles?.isEmployee) && {
        name: 'itemtotal',
        title: words.total,
      },
      { name: 'manualDocNo', title: isRTL ? 'رقم المستند' : 'Document No' },
      { name: 'manualRefNo', title: isRTL ? 'رقم المرجع' : 'Reference No' },
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: 'index', width: 50 },
    { columnName: isRTL ? 'nameAr' : 'name', width: 150 },
    { columnName: 'relations', width: 150 },
    { columnName: 'note', width: 150 },
    { columnName: 'itemprice', width: 80 },
    { columnName: 'itemqty', width: 70 },
    { columnName: 'itemtotal', width: 80 },
    { columnName: 'manualDocNo', width: 80, align: 'center' },
    { columnName: 'manualRefNo', width: 80, align: 'center' },
  ]);

  const renderEmpty = () => {
    return <Box display="flex"></Box>;
  };

  return (
    <Paper
      elevation={5}
      style={{
        overflow: 'auto',
        margin: 10,
        minHeight: 250,
      }}
    >
      <Typography style={{ fontWeight: 'bold', padding: 10, fontSize: 22 }}>
        {isRTL ? 'البنود' : 'Items'}
      </Typography>
      {rows && (
        <Grid rows={rows} columns={columns} getRowId={getRowId}>
          <DragDropProvider />
          <Table
            noDataCellComponent={renderEmpty}
            columnExtensions={tableColumnExtensions}
            tableComponent={TableComponent}
          />
          <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

          <TableHeaderRow
            titleComponent={({ children }) => {
              return (
                <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                  {children}
                </Typography>
              );
            }}
          />
          <IndexProvider for={['index']} />
          <DataTypeProvider
            for={['itemtotal', 'itemprice']}
            formatterComponent={currencyFormatter}
          ></DataTypeProvider>
          <DataTypeProvider
            for={['itemqty']}
            formatterComponent={quantityFormatter}
          ></DataTypeProvider>
          <DataTypeProvider
            for={['relations']}
            formatterComponent={(props: any) =>
              renderRelations({ ...props, isRTL })
            }
          ></DataTypeProvider>
        </Grid>
      )}
    </Paper>
  );
}
